module.exports = __webpack_public_path__ + "static/assisted-c7486002842102660befa4791b3ef94e.png";